import React from "react";
import { useNavigate } from "react-router-dom";
import { Star, Shield, MessageSquare, User, CheckCircle } from "lucide-react";
import { useCountry } from "../contexts/CountryContext";

const JoinAsProPage = () => {
  const navigate = useNavigate();
  const { country } = useCountry();
  const prefix = country.currencyPrefix;
  const gst = country.gstLabel;

  return (
    <div className="page join-pro-page">
      <div className="join-pro-hero">
        <h1>Grow Your Business with HandyHub</h1>
        <p>Join thousands of service professionals reaching new customers every day</p>
        <button
          onClick={() => navigate('/signup?role=provider')}
          className="btn-primary btn-large"
          data-testid="get-started-btn"
        >
          Get Started
        </button>
      </div>

      <div className="benefits-section">
        <h2>Why Join HandyHub?</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon"><User /></div>
            <h3>Reach More Customers</h3>
            <p>Get discovered by thousands of customers looking for your services</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon"><Shield /></div>
            <h3>Build Trust</h3>
            <p>Verification badges help you stand out and build credibility</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon"><Star /></div>
            <h3>Grow Your Reputation</h3>
            <p>Collect reviews and ratings to showcase your expertise</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon"><MessageSquare /></div>
            <h3>Direct Communication</h3>
            <p>Connect directly with customers and manage quote requests</p>
          </div>
        </div>
      </div>

      <div className="pricing-section">
        <h2>Simple, Transparent Pricing</h2>
        <div className="pricing-grid">
          <div className="pricing-card">
            <h3>Monthly</h3>
            <div className="price" data-testid="join-monthly-price">{prefix}49<span> + {gst} / month</span></div>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginTop: '-4px', marginBottom: '8px' }}>{gst} calculated at checkout</p>
            <ul>
              <li><CheckCircle size={16} /> Unlimited quote leads</li>
              <li><CheckCircle size={16} /> Business profile</li>
              <li><CheckCircle size={16} /> Customer messaging</li>
              <li><CheckCircle size={16} /> Review management</li>
            </ul>
            <button
              onClick={() => navigate('/signup?role=provider&plan=monthly')}
              className="btn-secondary"
            >
              Start Monthly
            </button>
          </div>
          <div className="pricing-card featured">
            <div className="popular-badge" data-testid="join-yearly-badge">{country.code === 'AU' ? 'Best Value' : 'Most Popular'}</div>
            <h3>Yearly</h3>
            <div className="price" data-testid="join-yearly-price">{prefix}{country.yearlyPrice}<span> + {gst} / year</span></div>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginTop: '-4px', marginBottom: '4px' }}>{gst} calculated at checkout</p>
            <div className="savings" data-testid="join-yearly-savings">{country.yearlySavingsLabel}</div>
            <ul>
              <li><CheckCircle size={16} /> Everything in Monthly</li>
              <li><CheckCircle size={16} /> Priority listing</li>
              <li><CheckCircle size={16} /> Featured badge</li>
              <li><CheckCircle size={16} /> Analytics dashboard</li>
            </ul>
            <button
              onClick={() => navigate('/signup?role=provider&plan=yearly')}
              className="btn-primary"
            >
              Start Yearly
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


export default JoinAsProPage;
